module.exports = __webpack_public_path__ + "img/ico-dash-ninja.864b1aec.svg";